import connectCommonGroups from "./connectCommonGroups";
import connectEditableTabsGroups from "./connectEditableTabsGroups";

export default {
  connectCommonGroups,
  connectEditableTabsGroups
};
